import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'orderBy'
})

export class OrderBy implements PipeTransform {
    transform(obj: any, sortBy: string): any {
        if (!obj) return;
        else if (!sortBy) return obj;

        var tempArray = [].concat(obj);
        var reversed = false;

        if (sortBy[0] === '-') {
            sortBy = sortBy.substring(1);
            reversed = true;
        }

        return obj.sort(function (a: any, b: any) {
            // var valueA: any = a[sortBy];
            // var valueB: any = b[sortBy];

            var valueA: any = fetchFromObject(a, sortBy);
            var valueB: any = fetchFromObject(b, sortBy);

            if (sortBy === "+" || sortBy === "-") {
                valueA = a;
                valueB = b;
            }

            if (typeof valueA === "string" || typeof valueB === "string") {
                if (!valueA) valueA = '';
                if (!valueB) valueB = '';
                return !reversed ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
            } else if ((typeof valueA) === "number" || (typeof valueB) === "number" || (typeof valueA) === "boolean" || (typeof valueB) === "boolean") {
                return !reversed ? valueA - valueB : valueB - valueA;
            } else if (typeof valueA === "object" && typeof valueB === "object" && Array.isArray(valueA) && Array.isArray(valueB)) {
                var lengthA = 0;
                var lengthB = 0;

                if (valueA) {
                    lengthA = valueA.length;
                }

                if (valueB) {
                    lengthB = valueB.length;
                }
                return !reversed ? lengthA - lengthB : lengthB - lengthA;
            }

            return 0;
        });

        function fetchFromObject(obj: any, prop: string): any {
            //property not found
            if (typeof obj === 'undefined' || !obj) return false;

            //index of next property split
            var _index = prop.indexOf('.');

            //property split found; recursive call
            if (_index > -1) {
                //get object at property (before split), pass on remainder
                return fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
            }
            return obj[prop];
        }
    }



}
